import script from "./menu-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./menu-list.vue?vue&type=script&setup=true&lang=ts"

import "./menu-list.vue?vue&type=style&index=0&id=9a613512&scoped=true&lang=scss"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a613512"]])

export default __exports__